import { REMOVE_ALBUM } from '../actionTypes'

export const removeAlbum = (album_id: string) => ({
  type: REMOVE_ALBUM.name,
  api: {
    url: 'albums/remove',
    data: { album_id },
  },
})
